import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  color: theme.palette.secondary.main,
  '& .CRTable': {
    '& .tableStyle': {
      // this class written in the translation file
      width: '100%',
      borderCollapse: 'collapse',
      '& tr': {
        '&:last-child': {
          backgroundColor: theme.palette.grey[50],
          color: theme.palette.grey[900],
        },
        '& td': {
          padding: theme.spacing(1),
          '&.bg': {
            backgroundColor: theme.palette.info.dark,
            color: theme.palette.common.fogWhite,
            borderBottom: `1px solid ${theme.palette.grey[100]}`,
          },
        },
      },
    },
  },
}));

export default StyledBox;
